


















































































































































































import { Component, Mixins, Ref, Watch } from "vue-property-decorator";
import FiltersMixin from "@/mixins/SpecialInitiatives/FiltersMixin";
import VWeekPicker from "@/components/VWeekPicker.vue";
import YearsSelector from "@/components/SpecialInitiatives/YearsSelector.vue";
import VSwitchButton from "@/components/VSwitchButton.vue";
import MultiLevelSelect from "@/components/MultiLevelSelect.vue";
import ComparisonGroupSelect from "@/components/ComparisonGroupSelect.vue";
import SpecialInitiatives from "@/services/SpecialInitiavesService";
import {
  ProductsCollection,
  ProductsCatalog,
  decodeExclusivityType,
} from "@/models/SpecialInitiatives/Product";
import { Route } from "vue-router";
import HeatmapTable, {
  HeatmapTableColumn,
  HeatmapTableRow,
} from "@/components/HeatmapTable.vue";
import {
  WeekPickerResult,
  WEEK_PICKER_MODALITY_WEEK_RANGE,
} from "@/interfaces/WeekPickerDataTypes";
import SpecialInitiativesChart, {
  ChartWeekRange,
} from "@/components/SpecialInitiatives/Chart.vue";
import VMultiSwitcher from "@/components/VMultiSwitcher.vue";
import VCheckButton from "@/components/VCheckButton.vue";
import LogoWithFallback from "@/components/LogoWithFallback.vue";
import EntryService from "@/services/EntryService";
import { Company, Brand, Product as BaseProduct } from "@/models";
import { Product } from "@/models/SpecialInitiatives/Product";
import Broadcaster, {
  BroadcastersCatalog,
  BroadcastersCollection,
} from "@/models/SpecialInitiatives/Broadcaster";
import SpecialInitiativesModulesTable, {
  SpecialInitiativesData,
  WeekRange,
} from "@/components/SpecialInitiatives/SpecialInitiativesModulesTable.vue";
import SpecialInitiativesMixin from "@/mixins/http/SpecialInitiatives";
import Broadcast from "@/models/SpecialInitiatives/Broadcast";
import BroadcastModal from "@/components/BroadcastModal.vue";
import VModal from "@/components/VModal.vue";
import NumberFormatter from "@/services/NumberFormatter";
import GetColorMixin from "@/mixins/SpecialInitiatives/GetColorMixin";

@Component({
  components: {
    VWeekPicker,
    YearsSelector,
    VSwitchButton,
    MultiLevelSelect,
    ComparisonGroupSelect,
    HeatmapTable,
    SpecialInitiativesChart,
    VMultiSwitcher,
    VCheckButton,
    LogoWithFallback,
    SpecialInitiativesModulesTable,
    BroadcastModal,
  },
})
export default class SpecialInitiativesProductView extends Mixins(
  FiltersMixin,
  SpecialInitiativesMixin,
  GetColorMixin
) {
  @Ref() readonly broadcastModal!: VModal;

  compareYearStart = 0;
  compareYearEnd = 0;
  disabled = false;
  loading = false;
  planCollapse = false;
  products: ProductsCatalog = {};
  broadcasters: BroadcastersCatalog = {};
  broadcast: Broadcast | null = null;
  totalWeeklySeconds = 0;

  productHeatmapColumns: HeatmapTableColumn[] = [];
  productHeatmapRows: HeatmapTableRow[] = [];
  company: Company | null = null;
  brand: Brand | null = null;
  product: BaseProduct | null = null;
  specialInitiativesProduct: Product | null = null;
  taxonomyHeatmapColumns: HeatmapTableColumn[] = [];
  taxonomyHeatmapRows: HeatmapTableRow[] = [];

  taxonomyOptions = [
    {
      id: "salesAgencies",
      text: "Concessionarie",
    },
    {
      id: "broadcasters",
      text: "Emittenti",
    },
    {
      id: "detailSI",
      text: "Dettaglio I.S.",
    },
  ];

  taxonomyValue: "salesAgencies" | "broadcasters" | "detailSI" =
    "salesAgencies";
  productId = "";

  @Watch("taxonomyValue")
  onTaxonomyChangedValue(value: string) {
    this.initData();
  }

  @Watch("productId")
  onCompanyIdChange(value: string) {
    this.loadData();
  }

  async beforeRouteUpdate(to: Route, from: Route, next: () => void) {
    if (to.params !== from.params) {
      this.productId = to.params.productId;
    } else {
      this.productId = from.params.productId;
    }
    this.loading = true;
    if (this.forceReloadFromApi) {
      await this.loadProduct();
      await this.loadBroadcasters();
      this.forceReloadFromApi = false;
    }
    await this.initData();
    this.loading = false;
    next();
  }

  get productHeatmapSortColumn() {
    if (this.productHeatmapColumns.length > 0) {
      return this.productHeatmapColumns[1];
    } else {
      return null;
    }
  }

  get exclusivityType() {
    if (!this.specialInitiativesProduct) {
      return "";
    }
    return `Esclusività: ${decodeExclusivityType(
      this.specialInitiativesProduct?.exclusivityType
    ).toLowerCase()}`;
  }

  get sectorCategoryClass() {
    if (!this.specialInitiativesProduct) {
      return "";
    }

    return `${this.specialInitiativesProduct?.sectorName} / ${this.specialInitiativesProduct?.categoryName} / ${this.specialInitiativesProduct?.className}`;
  }

  get groupBySalesAgencies() {
    return this.taxonomyValue === "salesAgencies";
  }

  get showModulesDetail() {
    return this.taxonomyValue === "detailSI";
  }

  get taxonomyHeatmapSortColumn() {
    if (this.taxonomyHeatmapColumns.length > 0) {
      return this.taxonomyHeatmapColumns[2];
    } else {
      return null;
    }
  }

  get title() {
    const subject = this.clientSubjectsEntries.find(
      (element) => element.id === this.clientSubject
    );
    return `Overview ${subject?.text}`;
  }

  get subjectTaxonomiesHash() {
    return JSON.stringify(this.subjectTaxonomies);
  }

  get currentUnitOfMeasurement(): string {
    if (this.unitOfMeasurement) {
      return (
        this.unitOfMeasurementsEntries.find(
          (e) => e.id === this.unitOfMeasurement
        )?.text || ""
      );
    } else {
      return "";
    }
  }

  get currentIdUnitOfMeasurement(): string {
    if (this.unitOfMeasurement) {
      return (
        this.unitOfMeasurementsEntries.find(
          (e) => e.id === this.unitOfMeasurement
        )?.id || ""
      );
    } else {
      return "";
    }
  }

  get showTaxonomies() {
    return this.clientSubject === "taxonomies";
  }

  get noData(): boolean {
    const keys = Object.keys(this.products);
    let result = true;
    keys.forEach((key) => {
      result =
        result && this.productsFromExclusivity(this.products[key]).length === 0;
    });
    return result;
  }

  compareYearToDisable(): number {
    if (this.filters.weekRange) {
      const yearCompareFilter = this.filters.weekRange.split(",");
      return Number.parseInt(yearCompareFilter[3]);
    }
    return 0;
  }

  weekRangesLabels(): ChartWeekRange[] {
    return Object.keys(this.products).map((weekRange) => {
      return {
        label: this.weekRangeToLabel(weekRange),
        columnName: `col-${weekRange}`,
      };
    });
  }

  async mounted() {
    await this.loadData();
  }

  private async loadData() {
    this.loading = true;

    this.product = await this.getProduct();
    if (this.product?.brand) {
      this.brand = this.product.brand;
    }
    if (this.product?.company) {
      this.company = this.product.company;
    }
    this.initCompareYearsRange();
    this.decodeFilters();
    await this.initFilters();
    await this.loadProduct();
    await this.loadBroadcasters();
    this.initData();
    this.loading = false;
  }

  private decodeFilters() {
    if (this.$route.query["unitOfMeasurement"]) {
      // && this.unitOfMeasurement === 'quoted_seconds') {
      if (this.$route.query["unitOfMeasurement"].indexOf("Secondi") >= 0) {
        this.$route.query["unitOfMeasurement"] = "Secondi";
      }
      if (this.$route.query["unitOfMeasurement"].indexOf("Spot") >= 0) {
        this.$route.query["unitOfMeasurement"] = "Spot";
      }
    } else {
      this.$route.query["unitOfMeasurement"] = "Secondi";
    }
  }

  private async getProduct() {
    if (this.productId.length === 0) {
      this.productId = this.$route.params.productId;
    }
    return await EntryService.getProduct(this.productId, "GET_PRODUCT");
  }

  get taxonomyLabel() {
    switch (this.taxonomyValue) {
      case "salesAgencies":
        return "Concessionarie";
      case "broadcasters":
        return "Emittenti";
      default:
        return "Dettaglio I.S.";
    }
  }

  private initData() {
    this.productHeatmapColumns = [
      {
        name: "product",
        label: "Prodotti",
        heatmapDisabled: true,
        locked: true,
      },
    ];
    this.taxonomyHeatmapColumns = [
      {
        name: "taxonomy",
        label: this.taxonomyLabel,
        heatmapDisabled: true,
        locked: true,
      },
      {
        name: "productCount",
        label: "Prodotti",
        small: true,
      },
    ];
    for (const weekRange in this.products) {
      this.productHeatmapColumns.push({
        name: `col-${weekRange}`,
        label: this.weekRangeToLabel(weekRange),
      });
      this.taxonomyHeatmapColumns.push({
        name: `col-${weekRange}`,
        label: this.weekRangeToLabel(weekRange),
      });
    }
    this.arrangeDataInTables();
  }

  private arrangeRowByName(
    kind: "product" | "taxonomy",
    database: { [key: string]: any },
    weekRange: string,
    product: Product,
    total: number
  ) {
    if (kind === "product") {
      const productRow = database[product.subjectName] || {
        product: product.subjectName,
        candidates: [product.iconUrl],
        sector: product.sectorName,
        category: product.categoryName,
        class: product.className,
      };
      productRow[`col-${weekRange}`] = this.cellValue(total, product);
      database[product.subjectName] = productRow;
    } else {
      const keyName = `${this.taxonomyValue}Name`;
      const key = product[keyName] as string;
      const taxonomyRow = database[key] || {
        taxonomy: key,
        candidates: [product.iconUrl],
        sector: product.sectorName,
        category: product.categoryName,
        class: product.className,
        productCount: product.productsCount,
      };
      taxonomyRow[`col-${weekRange}`] = this.cellValue(total, product);
      database[key] = taxonomyRow;
    }
  }

  private arrangeDataInTables() {
    this.productHeatmapRows = [];
    this.taxonomyHeatmapRows = [];
    const productDatabase: { [key: string]: any } = {};
    const taxonomyDatabase: { [key: string]: any } = {};
    for (const weekRange in this.products) {
      const collection = this.products[weekRange];
      const products = this.productsFromExclusivity(collection);
      const total = this.getTotals(products);
      products.forEach((product) => {
        this.arrangeRowByName(
          "product",
          productDatabase,
          weekRange,
          product,
          total
        );
        this.arrangeRowByName(
          "taxonomy",
          taxonomyDatabase,
          weekRange,
          product,
          total
        );
      });
    }
    this.productHeatmapRows = [];
    for (const subject in productDatabase) {
      const row: any = {};
      row["brand"] = subject;
      row["sector"] = productDatabase[subject].sector;
      row["category"] = productDatabase[subject].category;
      row["class"] = productDatabase[subject].class;
      row["candidates"] = productDatabase[subject].candidates;
      this.productHeatmapColumns.forEach((column) => {
        row[column.name] =
          productDatabase[subject][column.name] || this.cellZeroValue();
      });
      this.productHeatmapRows.push(row);
    }
    for (const subject in taxonomyDatabase) {
      const row: any = {};
      row["taxonomy"] = subject;
      row["sector"] = taxonomyDatabase[subject].sector;
      row["category"] = taxonomyDatabase[subject].category;
      row["class"] = taxonomyDatabase[subject].class;
      row["candidates"] = taxonomyDatabase[subject].candidates;
      this.taxonomyHeatmapColumns.forEach((column) => {
        row[column.name] =
          taxonomyDatabase[subject][column.name] || this.cellZeroValue();
      });
      this.taxonomyHeatmapRows.push(row);
    }
  }

  private cellValue(total: number, product: Product) {
    const cellValue = product[this.columnFromUnitOfMeasurement()];

    if (
      this.unitOfMeasurement == "quoted_seconds" ||
      this.unitOfMeasurement == "quoted_spots"
    ) {
      return {
        type: "quoted",
        value: cellValue,
        quote: this.cellQuoteFromTotal(total, product),
      };
    }
    return cellValue;
  }

  private cellQuoteFromTotal(total: number, product: Product) {
    const cellValue = product[this.columnFromUnitOfMeasurement()];
    return `${NumberFormatter.format(cellValue)} (${Number(
      (cellValue / total) * 100
    ).toFixed(0)}%)`;
  }

  private cellZeroValue() {
    if (
      this.unitOfMeasurement == "quoted_seconds" ||
      this.unitOfMeasurement == "quoted_spots"
    ) {
      return {
        type: "quoted",
        value: 0,
        quote: 0,
      };
    }
    return 0;
  }

  private columnFromUnitOfMeasurement() {
    if (
      this.unitOfMeasurement === "seconds" ||
      this.unitOfMeasurement === "quoted_seconds"
    ) {
      return "secondsCount";
    } else if (
      this.unitOfMeasurement === "spots" ||
      this.unitOfMeasurement === "quoted_spots"
    ) {
      return "detectionsCount";
    } else {
      return "companiesCount";
    }
  }

  private getTotals(broadcasters: Product[]) {
    const fieldName = this.columnFromUnitOfMeasurement();
    return broadcasters.reduce((acc, broadcaster) => {
      return acc + broadcaster[fieldName];
    }, 0);
  }

  private productsFromExclusivity(broadcasters: ProductsCollection) {
    if (this.exclusivity === "all") {
      return broadcasters.productsAll;
    } else if (this.exclusivity === "my_exclusivity_type") {
      return broadcasters.productsMine;
    } else if (this.exclusivity === "others_exclusivity_type") {
      return broadcasters.productsOthers;
    } else if (this.exclusivity === "shared_exclusivity_type") {
      return broadcasters.productsShared;
    } else {
      return [];
    }
  }

  private weekRangeToLabel(weekRange: string) {
    if (weekRange) {
      const [w1, y1, w2, y2] = weekRange.split(",");
      const weekPickerRange: WeekPickerResult = {
        type: WEEK_PICKER_MODALITY_WEEK_RANGE,
        start: {
          week: Number.parseInt(w1),
          year: Number.parseInt(y1),
        },
        end: {
          week: Number.parseInt(w2),
          year: Number.parseInt(y2),
        },
      };
      return `Settimane ${VWeekPicker.resultToHumanReadable(weekPickerRange)}`;
    }
    return "";
  }

  async loadProductsFromApi(
    weekRange: string,
    saveSpecialInitiativesProduct = false
  ) {
    const filter = this.filtersForAPI("client");
    filter.weekRange = weekRange;
    const productsAll = await SpecialInitiatives.getProductsForBrand(
      filter,
      undefined,
      this.productId
    );
    if (saveSpecialInitiativesProduct) {
      this.specialInitiativesProduct = productsAll[0];
    }

    this.products[weekRange] = productsAll.reduce(
      (acc, product) => {
        switch (product.exclusivityType) {
          case "mine":
            acc.productsMine.push(product);
            break;
          case "others":
            acc.productsOthers.push(product);
            break;
          case "shared":
            acc.productsShared.push(product);
            break;
        }
        return acc;
      },
      {
        productsAll,
        productsMine: [] as Product[],
        productsOthers: [] as Product[],
        productsShared: [] as Product[],
      }
    );
  }

  async loadProduct() {
    this.loading = true;
    this.products = {};
    const filter = this.filtersForAPI("client");
    if (filter.weekRange) {
      await this.loadProductsFromApi(filter.weekRange, true);
      if (this.yearsToCompare && this.yearsToCompare.length > 0) {
        const weekRanges = this.compareYearsToWeekRanges();
        for (const weekRange of weekRanges) {
          await this.loadProductsFromApi(weekRange);
        }
      }
    }
    this.loading = false;
  }

  async loadBroadcastersFromApi(weekRange: string) {
    const filter = this.filtersForAPI("market");
    filter.weekRange = weekRange;
    const broadcastersAll = await SpecialInitiatives.getProductBroadcasters(
      filter,
      this.productId
    );
    const originalBroadcasters = broadcastersAll.map((o) =>
      Object.assign({}, o)
    );
    this.broadcasters[weekRange] = broadcastersAll.reduce(
      (acc, broadcaster) => {
        switch (broadcaster.exclusivityType) {
          case "mine":
            acc.broadcastersMine.push(broadcaster);
            break;
          case "others":
            acc.broadcastersOthers.push(broadcaster);
            break;
          case "shared":
            acc.broadcastersShared.push(broadcaster);
        }

        return acc;
      },
      {
        broadcastersAll: [] as Broadcaster[],
        broadcastersAllWithModules: originalBroadcasters,
        broadcastersMine: [] as Broadcaster[],
        broadcastersOthers: [] as Broadcaster[],
        broadcastersShared: [] as Broadcaster[],
      }
    );

    const allExclusivityBroadcasters: Broadcaster[] = [];
    for (const broadcaster of broadcastersAll) {
      const broadcasterSameSalesAgency = allExclusivityBroadcasters.find(
        (o) =>
          o.currentAgency === broadcaster.currentAgency &&
          o.brandName === broadcaster.brandName
      );
      if (broadcasterSameSalesAgency) {
        broadcasterSameSalesAgency.detectionsCount =
          broadcasterSameSalesAgency.detectionsCount +
          broadcaster.detectionsCount;
        broadcasterSameSalesAgency.secondsCount += broadcaster.secondsCount;
      } else {
        allExclusivityBroadcasters.push(broadcaster);
      }
    }
    this.broadcasters[weekRange].broadcastersAll = allExclusivityBroadcasters;
  }

  async loadBroadcasters() {
    this.loading = true;
    this.broadcasters = {};
    const filter = this.filtersForAPI("market");
    if (filter.weekRange) {
      await this.loadBroadcastersFromApi(filter.weekRange);
      if (this.yearsToCompare && this.yearsToCompare.length > 0) {
        const weekRanges = this.compareYearsToWeekRanges();
        for (const weekRange of weekRanges) {
          await this.loadBroadcastersFromApi(weekRange);
        }
      }
    }
    this.loading = false;
  }

  private compareYearsToWeekRanges(): string[] {
    const filter = this.filtersForAPI("client");
    const weekRanges: string[] = [];
    if (
      filter.weekRange &&
      this.yearsToCompare &&
      this.yearsToCompare.length > 0
    ) {
      const [w1, y1, w2, y2] = filter.weekRange.split(",");
      const baseYearEnd = Number.parseInt(y2);
      const baseYearStart = Number.parseInt(y1);
      const years = [...this.yearsToCompare];
      for (const year of years.reverse()) {
        const cmpYear = Number.parseInt(year);
        const compareResult = cmpYear - baseYearEnd;
        if (compareResult != 0) {
          const compareWeekRange = [
            w1,
            `${baseYearStart + compareResult}`,
            w2,
            `${baseYearStart + compareResult}`,
          ];
          weekRanges.push(compareWeekRange.join(","));
        }
      }
    }
    return weekRanges;
  }

  private async onBroadcastClick(obj: any) {
    this.broadcast = await this.getBroadcast(obj.broadcastId);
    this.totalWeeklySeconds = obj.totalWeeklySeconds;
    this.broadcastModal.show();
  }

  private initCompareYearsRange() {
    this.compareYearStart = this.$moment().year();
    this.compareYearEnd = this.compareYearStart - this.compareYearsRange;
  }

  specialInitiativesWeekRanges(): WeekRange[] {
    const weekRanges: WeekRange[] = [];
    for (const weekRange in this.broadcasters) {
      weekRanges.push({
        name: `col-${weekRange}`,
        label: this.weekRangeToLabel(weekRange),
      });
    }
    return weekRanges;
  }

  tableQuoted() {
    return this.unitOfMeasurement?.startsWith("quoted");
  }

  private broadcastersFromExclusivity(broadcasters: BroadcastersCollection) {
    if (this.exclusivity === "all") {
      if (this.showModulesDetail) {
        return broadcasters.broadcastersAllWithModules || [];
      } else {
        return broadcasters.broadcastersAll;
      }
    } else if (this.exclusivity === "my_exclusivity_type") {
      return broadcasters.broadcastersMine;
    } else if (this.exclusivity === "others_exclusivity_type") {
      return broadcasters.broadcastersOthers;
    } else if (this.exclusivity === "shared_exclusivity_type") {
      return broadcasters.broadcastersShared;
    } else {
      return [];
    }
  }

  broadcastersToTableData(): SpecialInitiativesData {
    const result: SpecialInitiativesData = {};
    for (const weekRange in this.broadcasters) {
      result[weekRange] = this.broadcastersFromExclusivity(
        this.broadcasters[weekRange]
      );
    }
    return result;
  }
}
